// extracted by mini-css-extract-plugin
export default {"successIcon":"styles__successIcon___C4fpD","loginFooter":"styles__loginFooter___wLjdB"};